import { Component, OnInit } from "@angular/core";
import { NotificationsService } from "./notifications.service";
import { ConfigService } from "../config.service";

@Component({
  selector: "create-notification",
  template: require('./createnotification.component.html'),
  styles: [require('./createnotification.component.scss')]
})
export class CreateNotificationComponent implements OnInit {
  activePanels = ["details"];
  languages: any[];
  countries: any[];
  projects: any[];
  employers: any[];
  apps: any[] = [...ConfigService.applications];
  notification = {
    language: "",
    nationality: [""],
    projects: [""],
    employer: [""],
    country: [""],
    app: null
  };
  clicked: boolean;

  constructor(private service: NotificationsService) {}

  ngOnInit() {
    this.languages = [{ value: "<any>", key: "" }];
    this.languages = this.languages.concat(this.service.getLanguages());
    this.countries = [{ name: "<any>", code: "" }];
    this.countries = this.countries.concat(this.service.getCountries());
    this.projects = [{ name: "<any>", id: "" }];
    this.service.getProjects().subscribe((projects) => {
      this.projects = this.projects.concat(projects);
    });
    this.employers = [{ name: "<any>", id: "" }];
    this.service.getEmployers().subscribe((employers) => {
      this.employers = this.employers.concat(employers);
    });
  }

  onSubmit() {
    this.clicked = true;
    this.service.sendNotification(this.notification).subscribe(
      (resp) => {
        this.back();
      },
      (error) => {
        this.clicked = false;
      }
    );
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/notifications/createnotification.component.ts